/**
 * Angular imports.
 */
import { Pipe, PipeTransform } from '@angular/core';

/**
 * Constant imports.
 */
import { HCF_TEMPLATES } from '../constants/app.constants';


/**
 * Pipe is used to handle the filtration for the hcf templates.
 */
@Pipe({
  name: 'hcfTemplateFilter',
  pure: false
})
export class HcfTemplateFilterPipe implements PipeTransform {
  public templateConstant = HCF_TEMPLATES;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform(hcfList: any[]): any {
    hcfList = hcfList.filter(list => list.template === this.templateConstant.ONE || list.template === this.templateConstant.TWO || list.template === this.templateConstant.THREE ||
      list.template === this.templateConstant.FOUR);
    return hcfList;
  }
}
